module.exports = __webpack_public_path__ + "img/adventure.cf1573c6.svg";